import { ISmartercodesState } from '../smartercodes.reducers';
import { IContext } from 'Dashboard/redux/dashboard.reducer';

export default function apiDataUniqueUsers(
    state: ISmartercodesState,
    rawApiData: any,
    context: IContext,
    extraParams: any
) {
    let newState = { ...state };
    // format `unique users` data however needed here!
    return newState;
}
